import moment from 'moment'
import { Link } from 'react-router-dom'
import useCallApi from '../../../hooks/useCallApi'
import Affiliate from '../../../templates/Affiliate/Affiliate'
import Loading from '../../../templates/UI/Loading/Loading'
import { useAuth, useProtectedPage } from '../../../context/AuthContext'
import useRunSystemJob from '../../../hooks/useRunJob'
import callAPI from '../../../helpers/callAPI'
import { SystemMessageContext } from '../../../context/SystemMessageContext'
import { useContext, useState } from 'react'

const PayoutInstructions = ({ }) => {

    document.title = 'Payout Instructions'
    const { showSystemMessage } = useContext(SystemMessageContext)
    const [confirmAffiliate, setConfirmAffiliate] = useState(null)
    const [runAffiliateId, setRunAffiliateId] = useState(null)

    const auth = useAuth()
    useProtectedPage(auth.permissions, 'payout_instructions')
    const { runSystemJobConfirm, setRunSystemJobConfirm, runSystemJob } = useRunSystemJob()
    const { dataLoaded, data, refetch } = useCallApi(`admin/performanceCandidateList`, 'GET', {}, [])

    const rejectPerformancebonus = async (affiliateId) => {
        let result = await callAPI(`admin/performancebonus/reject`, 'POST', { affiliateId: affiliateId }, false)
        if (result) {
            if (result.success) {
                showSystemMessage('success', 'Performance bonus rejected.')
                refetch()
            } else {
                showSystemMessage('error', 'Failed to reject performance bonus.')
            }
        }
    }

    const runAffiliate = async (affiliateId) => {
        const item = data.list_new.find(i => i.affiliate_id === affiliateId)
        if (!item) return

        const scripts = {
            addTransaction: `exec add_affiliate_transaction ${item.affiliate_id}, ${item.bonus_value}, '${moment().format('YYYY-MM-DD HH:mm:ss')}', 'E', '${item.notes}', ''`,
            updateBonus: `UPDATE affiliate_bonus SET status = 'P' WHERE affiliate_bonus_id = ${item.affiliate_bonus_id}`
        }

        let result = await callAPI(`admin/performancebonus/run`, 'PUT', {
            affiliateId: affiliateId,
            scripts: scripts
        }, false)
        if (result) {
            if (result.success) {
                showSystemMessage('success', 'Performance bonus processed for affiliate.')
                refetch()
                setRunAffiliateId(null)
            } else {
                showSystemMessage('error', 'Failed to process performance bonus for affiliate.')
            }
        }
    }

    return (
        <div>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Affiliate Payout Processing</h1>
            </div>
            <div className="card">
                <div className="p-3">
                    <table className="m-0 w-100">
                        <tbody>
                            <tr>
                                <td>
                                    <b>
                                        <u>Weeklies - to be done on Wednesdays</u>
                                    </b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b>Step 1 - Generate Payment Files</b>
                                    <br />- If they haven't come via e-mail, or you need to regenerate them, use the below links: {' '}
                                    <div>                                        
                                        {!runSystemJobConfirm ?
                                            <button className="btn btn-sm btn-primary mt-2" onClick={() => { setRunSystemJobConfirm(true) }}>
                                                Generate Payment Files
                                            </button>
                                            :
                                            <button className="btn btn-sm btn-primary mt-2" onClick={() => { runSystemJob({ job_id: 23 }, () => { }) }}>
                                                Confirm
                                            </button>
                                        }
                                    </div>
                                    <br />
                                    <b>Step 2 - Payments via Tipalti </b>
                                    <br />
                                    - Upload and process the Tipalti file in the Tipalti interface
                                    <br />
                                    <br />
                                    <br />
                                    <b>Step 3 - Payments via Payoneer </b>
                                    <br />
                                    - Upload and process the Payoneer file in the Payoneer interface
                                    <br />
                                    <br />
                                    <br />
                                    <b>Step 4 - Update Balances</b>
                                    <br />
                                    - Login to SQL Server and get into MaxBounty database in SQL Server Management Studio
                                    <br />- Run the SQL script{' '}
                                    <b>
                                        <u>ONCE</u>
                                    </b>{' '}
                                    sent via e-mail in query window
                                    <br />
                                    <br />
                                    <br />
                                    <b>Step 5 - Send Notices</b>
                                    <br />- Send the{' '}
                                    <Link to={`/affiliates/paymentNotices`} target="_blank">
                                        payment notifications
                                    </Link>
                                    <br />
                                    <br />
                                </td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td className="smalltext" align="left">
                                    <b>
                                        <u>Mid Month - After Reversals, Before 15th of the month</u>
                                    </b>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b>Step 1 - Verify Performance Bonuses</b>
                                    <br />
                                    Look through affiliate stats to identify anyone who has qualified for the performance bonus. If they have, manually add the bonus to their account and notify the AM so they can be congratulated.<br />
                                    <br /> Here are the candidates this month (New Program):
                                    <br />
                                    <br />
                                    {dataLoaded ? (
                                        data.list_new &&
                                        <div className='d-flex w-100'>
                                            <table className="table table-striped table-hover mr-1" style={{ width: '15%' }}>
                                                <tbody>
                                                    {data.list_new.map((item) => {
                                                        return (
                                                            <tr>
                                                                <td><span className="text-small mr-1">{item.affiliate_id}:</span> <Affiliate aid={item.affiliate_id} name={item.name} status={item.status} priority={item.aff_priority} /></td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                            <table className="table table-striped table-hover" style={{ width: '85%' }}>
                                                <tbody>
                                                    {data.list_new.map((item) => {
                                                        return (
                                                            <tr>
                                                                <td>
                                                                    <font face="courier">
                                                                        exec add_affiliate_transaction {item.affiliate_id}, {item.bonus_value}, '{moment().format('YYYY-MM-DD HH:mm:ss')}', 'E', '{item.notes}', '' <br />
                                                                        UPDATE affiliate_bonus SET status = 'P' WHERE affiliate_bonus_id = {item.affiliate_bonus_id}
                                                                    </font>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                            <table className="table table-striped table-hover" style={{ width: '85%' }}>
                                                <tbody>
                                                    {data.list_new.map((item) => {
                                                        return (
                                                            <tr>
                                                                <td>
                                                                    {confirmAffiliate === item.affiliate_id ?
                                                                        <button className="btn btn-sm btn-danger" onClick={() => rejectPerformancebonus(item.affiliate_id)}>Confirm</button>
                                                                        :
                                                                        <button className="btn btn-sm btn-outline-danger" onClick={() => setConfirmAffiliate(item.affiliate_id)}>Reject From Bonus</button>
                                                                    }
                                                                    {
                                                                        runAffiliateId === item.affiliate_id ?
                                                                            <button className="btn btn-sm btn-primary ml-2" onClick={() => runAffiliate(item.affiliate_id)}>Confirm</button>
                                                                            :
                                                                            <button className="btn btn-sm btn-outline-primary ml-2" onClick={() => setRunAffiliateId(item.affiliate_id)}>Approve Bonus</button>
                                                                    }

                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <Loading />
                                    )}
                                    {/* <br /> Here are the candidates this month (Old Program):
                                    <br />
                                    <br />
                                    {dataLoaded ? (
                                        data.list &&
                                        data.list.map((item) => {
                                            return (
                                                <>
                                                    <span className="text-small mr-1">{item.affiliate_id}:</span>
                                                    <Affiliate aid={item.affiliate_id} name={item.name} status={item.status} priority={item.aff_priority} />
                                                    <br />
                                                </>
                                            )
                                        })
                                    ) : (
                                        <Loading />
                                    )} */}
                                    <br />
                                    <br />
                                    <b>Step 2 - Process Referral Income</b>
                                    <br />
                                    Process the referral income for affiliates by running this procedure in a SQL Server Management Studio window:
                                    <br />
                                    <br />
                                    <font face="courier">
                                        exec process_affiliate_referral '{moment().subtract(1, 'month').startOf('month').format('YYYY/MM/DD')}' , '{moment().subtract(1, 'month').endOf('month').format('YYYY/MM/DD')}'
                                    </font>
                                    <br />
                                    <br />
                                    <br />
                                    <b>Step 3 - Set Payment Flags</b>
                                    <br />
                                    Run the script to set the Received Payment Flag in a SQL Server Management Studio window
                                    <br />
                                    <font face="courier">exec set_paymentreceived_flag</font>
                                    <br />
                                    <br />
                                    <br />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default PayoutInstructions
